import React from 'react';
export function HeroSection() {
  return <section className="relative w-full h-screen flex items-center justify-center bg-cover bg-center" style={{
    backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.65)), url('https://uploadthingy.s3.us-west-1.amazonaws.com/rnbBJDcYvcq8pf2uE3Esox/image.png')"
  }} data-id="element-26">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-[#8d6e4b]/60" data-id="element-27"></div>
      <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-5xl" data-id="element-28">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-29">
          Créer localement un matériau d'avenir à base de terre recyclée
        </h1>
        <p className="text-xl md:text-2xl text-white mb-10 max-w-3xl mx-auto" data-id="element-30">
          Performance industrielle & respect de l'environnement, pour bâtir le
          futur.
        </p>
      </div>
      <div className="absolute bottom-8 left-0 right-0 flex justify-center animate-bounce" data-id="element-31">
        <a href="#vision" className="text-white" data-id="element-32">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-33">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" data-id="element-34" />
          </svg>
        </a>
      </div>
    </section>;
}